module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"main_title":"Recommended authors"},"cs":{"main_title":"Doporučení autoři"}}')
  delete Component.options._Ctor
}
